<form *ngIf="block && form" [formGroup]="form">
  <pl-textarea
    class=""
    #plTextarea
    [formControlName]="FormControlName.textarea"
    [height]="block.data.config.class === 'large-height' ? TextAreaHeight.large : TextAreaHeight.medium"
    [isDisabled]="isDisabled"
    [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
    [label]="block.data.label || ''"
    [minNumberWords]="block.data.config.minNumberWords"
    [placeholder]="block.data.placeholder || ''"
  />
</form>
